import React, { SVGProps } from 'react';

export const Undo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.062 15.646c.241.847.571 1.657.98 2.42L2.008 18a10.285 10.285 0 0 0 3.938 3.949l.052.026a12.043 12.043 0 0 0 6.007 1.424 12.147 12.147 0 0 0 6.058-1.457l-.065.033a10.29 10.29 0 0 0 3.964-3.925l.026-.05a12.096 12.096 0 0 0 1.41-6.01l.002-.176c0-2.135-.557-4.139-1.533-5.876l.032.06a10.11 10.11 0 0 0-3.851-3.948l-.05-.026A12.034 12.034 0 0 0 11.99.598 12.203 12.203 0 0 0 6 2.098a10.192 10.192 0 0 0-3.1 2.6V1H1.1v6.8H8V6.1H4.118a8.367 8.367 0 0 1 2.74-2.478L6.9 3.6a10.367 10.367 0 0 1 5.105-1.2c.064-.002.14-.002.215-.002 1.785 0 3.465.444 4.937 1.23L17.1 3.6a8.417 8.417 0 0 1 3.278 3.273l.022.043a10.174 10.174 0 0 1 1.2 5.092l.002.233c0 1.773-.446 3.441-1.23 4.9l.027-.055a8.31 8.31 0 0 1-3.272 3.293l-.042.022a10.195 10.195 0 0 1-5.093 1.2 10.455 10.455 0 0 1-5.15-1.228l.056.028a8.366 8.366 0 0 1-3.278-3.287l-.022-.043a9.901 9.901 0 0 1-.81-2.001l-1.727.576ZM11.993 21.6H12h-.013.006ZM21.6 12.008V12v.013-.006ZM12.005 2.4H12h.011-.006Z"
    />
  </svg>
);
